import styled from 'styled-components';
import {
  Box,
  Typography,
  Button,
  Paper,
  Dialog,
  DialogContent as MuiDialogContent,
  DialogActions as MuiDialogActions,
} from '@mui/material';

export const Container = styled(Box)`
  padding: 24px;
  position: relative;
`;

export const ContentWrapper = styled(Box)`
  margin: 0 auto;
`;

export const Title = styled(Typography)`
  font-size: 18px;
  font-weight: 500;
  color: #333;
`;

export const CreateButton = styled(Button)`
  background-color: #2d73dc;
  color: #fff;
  width: 150px;
  height: 45px;
  border-radius: 4px;
`;

export const EmptyStateContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 24px;
`;

export const MessageText = styled(Typography)`
  color: #8e8e8d;
  text-align: center;
  margin-top: 16px;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
`;

// Card
export const CardContainer = styled(Paper)`
  background-color: #fff;
  padding: 16px 24px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
`;

export const Inner = styled.div`
  display: flex;
  align-items: center;
  gap: 60px;
  flex: 1;
`;

export const CardItem = styled.div<{ $withBorder?: boolean }>`
  display: flex;
  gap: 30px;
  width: 100%;
  max-width: 250px;
  align-items: center;
  margin-left: ${props => (props.$withBorder ? '30px' : 'none')};
  padding-left: ${props => (props.$withBorder ? '10px' : 'none')};
  border-left: ${props => (props.$withBorder ? '1px solid #ddd' : 'none')};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-left: 20px;
`;

export const FuncButton = styled(Button)`
  background-color: #1a8754;
  color: #fff;
  width: 70px;
  height: 38px;
  border-radius: 4px;
  &:hover {
    background-color: #157347;
  }
`;

export const Divider = styled.span`
  color: #ddd;
`;

export const StyledDialog = styled(Dialog).attrs({
  PaperProps: {
    style: {
      borderRadius: 8,
      padding: '20px',
      width: 500,
      maxWidth: '90%',
    },
  },
})``;

export const ModalContent = styled(MuiDialogContent)`
  padding: 0;
  text-align: center;
`;

export const TitleText = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #222;
  display: flex;
  align-items: center;
  gap: 8;
  justify-content: center;
`;

export const DescText = styled.p`
  margin-top: 12px;
  font-size: 14px;
  color: #666;
  white-space: pre-line;
`;

export const Actions = styled(MuiDialogActions)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const CancelBtn = styled(Button)`
  && {
    min-width: 100px;
    border: 1px solid #ccc;
    color: #333;
    background: #fff;
    font-size: 14px;
    &:hover {
      background: #fafafa;
    }
  }
  width: 100%;
`;

export const DeleteBtn = styled(Button)`
  && {
    min-width: 100px;
    background: #ff3b30;
    color: #fff;
    font-size: 14px;
    &:hover {
      background: #e0352c;
    }
  }
  width: 100%;
`;

export const SearchWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .title {
    color: #000000b2;
    font-size: 14px;
    font-weight: 500;
  }
`;

export const SectionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
`;

export const SectionWrap = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 8px;
  .title {
    color: #000000b2;
    font-size: 14px;
    font-weight: 500;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  min-height: 600px;
  max-height: 600px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const SearchSection = styled(Section)`
  background-color: #ffffff;
`;

export const RegisteredSection = styled(Section)`
  background-color: #f7fffc;
  border-color: #c8e6dd;
`;

export const ListHeader = styled.div<{ $bg: string }>`
  display: flex;
  align-items: center;
  background-color: ${props => props.$bg};
  border-bottom: 1px solid #ddd;
  position: sticky;
  top: 0;
  z-index: 1;
  min-height: 48px;
`;

export const CheckboxCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  flex-shrink: 0;
`;

export const HeaderCell = styled.div<{
  $width?: string;
  $hasBorderBefore?: boolean;
}>`
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 12px;
  font-size: 14px;
  font-weight: bold;
  color: #000000b2;
  flex: ${props => (props.$width ? props.$width : '1')};

  ${props =>
    props.$hasBorderBefore !== undefined
      ? props.$hasBorderBefore
        ? `
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        height: 10px;
        width: 1px;
        background-color: black;
      }
    `
        : ``
      : `
      &:not(:first-child):not(:last-child)::before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        height: 10px;
        width: 1px;
        background-color: black;
      }
    `}
`;

export const ListRow = styled.div<{
  $isLast?: boolean;
  $highlighted?: boolean;
}>`
  display: flex;
  align-items: center;
  min-height: 48px;
  border-bottom: ${props => (props.$isLast ? 'none' : '1px solid #e0e0e0')};
  background-color: ${props =>
    props.$highlighted ? '#e8f5e933' : 'transparent'};
  cursor: pointer;

  &:hover {
    background-color: ${props => (props.$highlighted ? '#e8f5e9' : '#C9EDDF')};
  }
`;

export const DataCell = styled.div<{
  $width?: string;
  $hasBorderBefore?: boolean;
}>`
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 12px;
  font-size: 14px;
  color: #333;
  flex: ${props => (props.$width ? props.$width : '1')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${props =>
    props.$hasBorderBefore !== undefined
      ? props.$hasBorderBefore
        ? `
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        height: 10px;
        width: 1px;
        background-color: black;
      }
    `
        : ``
      : `
      &:not(:first-child):not(:last-child)::before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        height: 10px;
        width: 1px;
        background-color: black;
      }
    `}
`;
